import React from 'react';

import styles from './AppContainerSpinner.module.scss';

import PageLoader from '../components/shared/PageLoader/PageLoader';

const AppContainerSpinner = () => (
  <div className={styles['app-container-overlay']}>
    <p className={styles['app-container-loading-message']}>
      {' '}
      Loading Account...{' '}
    </p>
    <PageLoader isVisible={true} height={'184'} width={'184'} />
  </div>
);

export default AppContainerSpinner;
